<template>
  <form @submit.prevent="validateBeforeSubmit">
    <div class="modal-card" style="width: 640px">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <b-field label="ID" v-if="id">
          <b-input placeholder="ID" disabled v-model="model.id"></b-input>
        </b-field>
        <template v-if="id">
          <b-field label="Дата заказа"
            :type="{'is-danger': errors.has('date')}"
            :message="[{
              'Обязательное поле для заполнения' : errors.firstByRule('date', 'required')
            }]">
            <b-datepicker
              name="date"
              placeholder="Выберите дату"
              icon="calendar-alt"
              disabled
              v-validate="'required'"
              v-model="model.date">
            </b-datepicker>
          </b-field>
        </template>
        <template v-if="!id">
          <b-field label="Дата заказа"
            :type="{'is-danger': errors.has('date')}"
            :message="[{
              'Обязательное поле для заполнения' : errors.firstByRule('date', 'required')
            }]">
            <b-datepicker
              name="date"
              placeholder="Выберите дату"
              icon="calendar-alt"
              v-validate="'required'"
              v-model="model.date">
            </b-datepicker>
          </b-field>
        </template>
        <b-field
          label="Ф.И.О."
          :type="{'is-danger': errors.has('client_name')}"
          :message="[{
            'Обязательное поле для заполнения' : errors.firstByRule('client_name', 'required')
          }]">
          <b-input
            name="client_name"
            placeholder="Ф.И.О."
            icon="user"
            v-validate="'required'"
            v-model="model.client_name">
          </b-input>
        </b-field>
        <b-field
          label="Электронной почта"
          :type="{'is-danger': errors.has('client_email')}"
          :message="[{
            'Адрес электронной почты обязательное поле для заполнения' : errors.firstByRule('client_email', 'required')
          }]">
            <b-input
              name="client_email"
              placeholder="Электронной почта"
              type="email"
              icon="at"
              v-validate="'required'"
              v-model="model.client_email">
            </b-input>
        </b-field>
        <b-field label="Номер телефона"
          :type="{'is-danger': errors.has('client_phone')}"
          :message="[{
            'Номер телефона обязательное поле для заполнения' : errors.firstByRule('client_phone', 'required')
          }]">
          <b-input
            name="client_phone"
            icon="phone"
            placeholder="Номер телефона"
            v-model="model.client_phone"
            v-validate="'required|min:11'">
          </b-input>
        </b-field>
        <template v-if="id">
          <b-field grouped group-multiline>
            <template v-for="item in charts">
              <div v-bind:key="item.id" class="control">
                <b-tag type="is-primary">{{item.name}}</b-tag>
              </div>
            </template>
          </b-field>
        </template>
        <template v-if="!id">
          <b-field grouped group-multiline>
            <template v-for="item in charts">
              <div v-if="item.selected" v-bind:key="item.id" class="control">
                <b-tag type="is-primary" closable @close="unSelected(item.id)">{{item.name}}</b-tag>
              </div>
            </template>
          </b-field>
        </template>
        <template v-if="!id">
          <b-field label="Поиск ЭНК">
            <b-autocomplete
                :data="data"
                placeholder="Введите название ЭНК для поиска и добавления в заказ"
                field="product_name"
                v-model="search"
                :loading="isFetching"
                @typing="getAsyncData"
                @select="option => addedToCharts(option)">

                <template slot-scope="props">
                  <div class="media">
                    <div class="media-content">
                      {{ props.option.name }}
                      <br>
                      <small>
                        southernmost_latitude : {{ props.option.south}}
                      </small>
                    </div>
                  </div>
                </template>
            </b-autocomplete>
          </b-field>
        </template>
        <template v-if="id">
          <b-field label="Сообщение">
            <b-input
              type="textarea"
              name="message"
              disabled
              v-model="model.message"></b-input>
          </b-field>
        </template>
        <template v-if="!id">
          <b-field label="Сообщение">
            <b-input
              type="textarea"
              name="message"
              v-model="model.message"></b-input>
          </b-field>
        </template>
        <b-field label="Менеджер">
          <b-select placeholder="Выбирете менеджера" expanded v-model="model.manager_id">
            <option
              v-for="option in managers"
              :value="option.id"
              :key="option.id">
              {{ option.username }}
            </option>
          </b-select>
        </b-field>
        <b-field label="Статус заказа">
          <b-select placeholder="Выбирете статус заказ" expanded v-model="model.state_id">
            <option
              v-for="option in states"
              :value="option.id"
              :key="option.id">
              {{ option.name }}
            </option>
          </b-select>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-primary">Сохранить</button>        
        <button class="button" type="button" @click="$parent.close()">Закрыть</button>
      </footer>
    </div>
  </form>
</template>

<script>
  import debounce from 'lodash/debounce'
  import { mapSearch } from "@/api"
  export default {
    props: {
      id: Number,
      title: String,
    },
    data() {
      const states = [
        {
          id: null,
          name: "Новый"
        }
      ]
      const managers = []
      const charts = []
      const data = []
      return {
        data: data,
        // selected: null,
        isFetching: false,
        search: "",
        model: {
          id: undefined,
          client_name: '',
          client_email: '',
          client_phone: '',
          user_id: undefined,
          manager_id: undefined,
          state_id: undefined,
          message: '',
          charts: null
        },
        purge_model: {
          id: undefined,
          client_name: '',
          client_email: '',
          client_phone: '',
          user_id: undefined,
          manager_id: undefined,
          state_id: undefined,
          message: '',
          charts: null
        },
        states: states,
        charts: charts,
        managers: managers
      }
    },
    mounted() {
      let $this = this
      
      if ($this.id){
        this.$store.dispatch('getOrder', $this.id)
          .then(response => {
            let data = response.data.data;
            for(let propertyName in data) {
              if(propertyName != "date" && propertyName != "charts"){
                $this.model[propertyName] = data[propertyName]
              }
              else{
                if(propertyName != "date"){
                  $this.charts = data[propertyName]
                }
                else{
                  $this.model[propertyName] = new Date(data[propertyName])
                }
              }
              
            }
          })
          .catch(error => {
            this.model = this.purge_model
          })
      }

      this.$store.dispatch('getManagers')
        .then(response => {
          let data = response.data.data;
          data.forEach((item) => {
            this.managers.push(item)
          })
        })
        .catch(error => {
          this.managers = []
        })

      this.$store.dispatch('getStates')
        .then(response => {
          let data = response.data.data;
          this.states = []
          data.forEach((item) => {
            this.states.push(item)
          })
        })
        .catch(error => {
          this.states = []
        })
      
    },
    computed: {
      //
    },
    methods: {
      validateBeforeSubmit() {
        let $this = this
        this.$validator.validateAll().then((result) => {
          if (result) {
            $this.doUpdate()
            return;
          }
          this.$toast.open({
            message: $this.$i18n.t('notify.form_error'),
            type: 'is-danger',
            position: 'is-bottom',
          })
        });
      },
      getAsyncData: debounce(function () {
        if (!this.search.length) {
            this.data = []
            return
        }

        this.isFetching = true
        
        mapSearch(this.search)
        .then(response => {
          let data = response.data.data;
          if (data.length){
            this.data = []
            data.forEach((item) => this.data.push(item))
          }
          else{
            this.data = []
          }
        })
        .catch(error => {
          this.data = []
        })

        this.isFetching = false

      }, 500),

      addedToCharts(option){
        let chart = {
          id: option.id,
          name: option.name,
          selected: true
        }

        let check = this.charts.filter(function(item){
          return item.id == option.id
        })

        if(!check.length){
          this.charts.push(chart)
        }
        else{
          this.$toast.open({
            message: this.$i18n.t('admin.order_enc_exist'),
            type: 'is-danger',
            position: 'is-bottom',
          })
        }
      },

      isSelected(item){
        return item.selected === true
      },

      unSelected(id){
        let $this = this
        $this.charts.forEach(function(item){
          if(item.id === id){
            item.selected = false
          }
        })
      },

      getChartsForOrder(){
        return this.charts.map(function(item){
          return item.id
        })
      },

      doUpdate(){
        let $this = this
        if ($this.id){
          let payload = this.model
          payload.charts = this.getChartsForOrder()
          this.$store.dispatch('updateOrder', payload)
        }
        else{
          let payload = this.model
          payload.charts = this.getChartsForOrder()
          // console.log(payload)
          this.$store.dispatch('createOrder', payload)
        }
      }

    }
  }
</script>